import { accessProperty } from "../data/accessProperty";

export const autoColumnWidth = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[],
  accessor: string,
  headerText: string | null,
  _maxWidth?: number,
  extraWidth: number = 0,
) => {
  function getStringWidth(string: string | null, font?: string) {
    if (!string) return 0;

    const offScreenElement = document.createElement("span");
    offScreenElement.style.whiteSpace = "nowrap";
    offScreenElement.style.font = font ?? "";
    offScreenElement.textContent = string;
    document.body.appendChild(offScreenElement);
    const width = offScreenElement.offsetWidth;
    document.body.removeChild(offScreenElement);
    return width;
  }

  const maxWidth = _maxWidth || 400;

  if (!data) return maxWidth;

  const textWidths = data.map((row) => {
    let textValue = "";
    if (row?.[accessor]) {
      textValue = `${row[accessor]}`;
    }

    if (accessor?.includes(".")) {
      textValue = accessProperty(accessor, row) || "";
    }

    return getStringWidth(textValue);
  });

  const width =
    Math.max(...textWidths, getStringWidth(headerText)) + extraWidth;

  return Math.min(maxWidth, width);
};
